import { getCookie, setCookie } from '../../utils/cookie';

const topBar = document.querySelector('.top-bar');

if (topBar && getCookie('wp-vb-top-bar') !== topBar.dataset.id) {
  topBar.style.display = 'block';
  const closeButton = document.querySelector('.top-bar__close-button');

  closeButton.addEventListener('click', () => {
    setCookie('wp-vb-top-bar', topBar.dataset.id, topBar.dataset.exp);
    topBar.classList.add('hidden');
  });
}